import { createFileRoute } from "@tanstack/react-router";

import { SessionsPage } from "../../../features/sessions/sessions-page";

export const Route = createFileRoute("/_app/settings/sessions")({ component: SessionsPage });
